import React, { useState } from 'react';
import MenuRow from './MenuRow';

const MenuSection = ({
  section,
  onClose,
  onAction,
  darkMode,
  onToggleTheme,
}) => {
  const [isOpen, setIsOpen] = useState(
    section.collapsible ? section.defaultOpen ?? false : true
  );

  const compact = section.compact ?? false;
  const canCollapse = section.collapsible && section.items.length > 0;

  const toggleOpen = () => {
    if (canCollapse) setIsOpen((prev) => !prev);
  };

  return (
    <section className="mb-1">
      {section.title ? (
        <button
          type="button"
          onClick={toggleOpen}
          disabled={!canCollapse}
          className={`
            flex items-center justify-between w-full min-h-[44px] px-2 rounded-lg
            text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400
            ${canCollapse ? 'hover:text-gray-700 dark:hover:text-gray-300 cursor-pointer' : 'cursor-default'}
          `}
          aria-expanded={canCollapse ? isOpen : undefined}
        >
          <span>{section.title}</span>
          {canCollapse && (
            <svg
              className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          )}
        </button>
      ) : null}

      {(!canCollapse || isOpen) && (
        <div className={compact ? 'space-y-0.5' : 'space-y-1'}>
          {section.items.map((item) => (
            <MenuRow
              key={item.id}
              item={item}
              compact={compact}
              onClose={onClose}
              onAction={onAction}
              darkMode={darkMode}
              onToggleTheme={onToggleTheme}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default MenuSection;
